export const COMPANY = {
  name: "Sefco",
  tagline: "Specialist in Platte Daken & Dakisolatie",
  ondernemingsnummer: "0704614532",
  email: "info@sefco.be",
  address: "Bekstraat 29, 3870 Heers",
  phone: "+32465178214",
  phoneDisplay: "+32 465 17 82 14",
  logo: "/sefco-logo.png",
  // Formspree endpoint voor het contactformulier
  formspreeEndpoint: "https://formspree.io/f/mbdvzkqk",
};
